import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'batp-dim-logo',
  templateUrl: './d-logo.component.html',
  styleUrls: ['./d-logo.component.css']
})
export class DLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
